import { Route, Switch, MemoryRouter } from "react-router-dom";
import './App.css';
import 'antd/dist/antd.css';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import React, { lazy, Suspense } from "react";
import { Spin } from 'antd';
import { getUrlParam } from './utility';
import $ from 'jquery';
// import MinimumScreenSizeAlert from './components/common/minimumScreenSizeAlert';

const DesignPage = lazy(() => import("./components/design"));
const EmbedPage = lazy(() => import("./components/embed"));
const OutlinePage = lazy(() => import("./components/outline"));
const HomePage = lazy(() => import("./components/home"));
const store = configureStore();

if(getUrlParam('nobranding') === 'true'){
  $('body').addClass('nobranding');
}

function App() {
  return (
    <Provider store={store}>
      <MemoryRouter>
        <Suspense
        fallback={
          <div className="pageLoader">
            <Spin size="large"/>
          </div>
        }
      >
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/outline" component={OutlinePage} />
          <Route exact path="/design" component={DesignPage} />
          <Route exact path='/embed' component={EmbedPage} />
        </Switch>
      </Suspense>
    </MemoryRouter>
  </Provider>
  );
}

export default App;
